import { Pipe, PipeTransform } from '@angular/core';

import startCase from 'lodash/startCase';

@Pipe({
    name: 'startcase',
    standalone: false
})
export class StartcasePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return startCase(value);
  }

}
